export default defineNuxtRouteMiddleware(async (to) => {
  const suggestedCountry = to.query['suggest-country'] as string
  const suggestedCountryRegion = to.query['suggest-country-region'] as string
  const suggestedLanguages = to.query['suggest-languages'] as string

  if (!suggestedCountry && !suggestedLanguages) return

  const user = useUser()

  const acceptSuggestedCountry = suggestedCountry && (!user.value || user.value?.accepting_suggestions.country)
  const acceptSuggestedCountryRegion = suggestedCountryRegion && (!user.value || user.value?.accepting_suggestions.country_region)
  const acceptSuggestedLanguages = suggestedLanguages && (!user.value || user.value?.accepting_suggestions.languages)

  const suggestedData: { country?: string, country_region?: string, languages?: string } = {}

  if (acceptSuggestedCountry) {
    if (user.value) user.value.accepting_suggestions.country = false
    suggestedData.country = suggestedCountry
  }

  if (acceptSuggestedCountryRegion) {
    if (user.value) user.value.accepting_suggestions.country_region = false
    suggestedData.country_region = suggestedCountryRegion
  }

  if (acceptSuggestedLanguages) {
    if (user.value) user.value.accepting_suggestions.languages = false
    suggestedData.languages = suggestedLanguages
  }

  if (acceptSuggestedCountry || acceptSuggestedLanguages) {
    await $larafetch('user-suggestions', {
      method: 'PUT',
      body: suggestedData
    })
  }

  delete to.query['suggest-country']
  delete to.query['suggest-country-region']
  delete to.query['suggest-languages']

  const router = useRouter()
  await router.replace(to)
})
